

















import { snakeCase } from 'lodash'
import { Node } from 'rete'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import CustomEditor from '../../../Editor/CustomEditor'
import { ErrorNode } from '../logic/ErrorNode'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class ErrorSampleNode extends Vue {
  @Prop() node!: ErrorNode

  @Prop() i18n!: i18n

  @Prop() editor!: CustomEditor

  get selected(): boolean {
    return this.editor.selected.contains(this.node as unknown as Node)
  }
}
